export const comments_5618949 = {"data":{"data":[],"links":{}}}